import { Box } from '@mui/material'
import PinStationsOnMap from '../../SetUpThird/components/PinStationsOnMap'
import type { GuidedStepComponentProps } from '../guidedSteps'

/**
 * SCRUM-1032 / SCRUM-1040 — Guided geotag step.
 *
 * The same screen the Excel import ends on: the stations that were just
 * created, beside a map, each waiting to be put where it actually is. Reused
 * rather than rebuilt so a station geotagged through the wizard is geotagged
 * exactly as one imported from a file.
 *
 * Nothing here is required. A controller works with none of its stations
 * pinned; the map is how an operator finds them later, which is worth doing
 * now and not worth blocking Finish over.
 */
const GeotagStep = ({ interfaceId }: GuidedStepComponentProps) => (
  <Box
    sx={{
      // The step area is the wizard's; this screen wants all of it, and it
      // carries its own panel chrome inside.
      height: '100%',
      minHeight: 0,
      display: 'flex',
      '& > *': { flex: 1, minWidth: 0 },
    }}
  >
    <PinStationsOnMap
      interfaceId={Number(interfaceId)}
      // The step area is a box of its own, not the viewport: without this the
      // panel's 100vh runs past the bottom of the wizard and the page scrolls.
      embedded
      // The wizard owns leaving: Back and Finish are on its footer, so the
      // panel's own dismiss is hidden rather than left as a dead control.
      hideClose
      onClose={() => undefined}
    />
  </Box>
)

export default GeotagStep
